import axios from "@/api/axiosInstance";
import { PublishCourseResponse } from "./types";

export const publishCourse = async (
  uuid: string,
): Promise<PublishCourseResponse> => {
  const response = await axios.patch<PublishCourseResponse>(
    `/api/private/learning-center/courses/${uuid}/publish`,
  );
  return response.data;
};
